export function isValidPanelData<T>(panelData: T | undefined): panelData is T {
  return panelData !== undefined
}

export function isValidSetPanelData<T>(
  setPanelData: React.Dispatch<React.SetStateAction<T>> | undefined
): setPanelData is React.Dispatch<React.SetStateAction<T>> {
  return setPanelData !== undefined
}
